// extracted by mini-css-extract-plugin
export default {"title":"_VNWQbTwHMZfhzOTcRLZ","guide":"zpXTL1d60JE3SoacsuF1","warning-icon":"vI9E9_n2OK4EosVKfopl","guide-list":"JEcVtLZNGHw1e0Pr_LgR","table-container":"jVJ740ERvnZSNXJVV2s3"};